import { useLayoutEffect } from "react";

/** Scroll do pierwszego pola z błędem walidacji (nie używać przy błędzie zapisu z API). */
export const useScrollToSurveyQuestion = (
  firstInvalidQuestionId: string | null,
  surveyValidationFailSeq: number
) => {
  useLayoutEffect(() => {
    if (surveyValidationFailSeq === 0 || !firstInvalidQuestionId) return;
    const escaped = firstInvalidQuestionId.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    const el = document.querySelector(`[data-survey-question-id="${escaped}"]`);
    el?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [surveyValidationFailSeq, firstInvalidQuestionId]);
};
